import { render, staticRenderFns } from "./Description.vue?vue&type=template&id=86ccaf2c&scoped=true&"
import script from "./Description.vue?vue&type=script&async=true&lang=js&"
export * from "./Description.vue?vue&type=script&async=true&lang=js&"
import style0 from "./Description.vue?vue&type=style&index=0&id=86ccaf2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ccaf2c",
  null
  
)

export default component.exports